// Merges an existing query string with explicit overrides while preserving all other params.
// This is used to keep referrer UTMs (e.g. utm_source) across route transitions
// that still need to add or update keys like userId without dropping the rest.
// Passing null/undefined removes a key, otherwise it is set/overwritten.
export const mergeSearchParams = (
  search: string | undefined,
  overrides: Record<string, string | null | undefined>
) => {
  const params = new URLSearchParams(search ?? '');

  Object.entries(overrides).forEach(([key, value]) => {
    if (value === null || value === undefined) {
      params.delete(key);
      return;
    }

    params.set(key, value);
  });

  const query = params.toString();
  return query ? `?${query}` : '';
};
